<template>
  <div class="videoManage">
    <h5 class="usertitle">视频管理</h5>
    <div class="info_nav">
      <div class="left">
        <div
          class="nav_item"
          v-for="(item, index) in navList"
          :key="index"
          :class="item.id === reqObj.status ? 'isA' : ''"
          @click="navClick(item)"
        >
          <span>{{ item.name }}</span>
          <!-- <span v-if="item.id === reqObj.status">（{{ total }}）</span> -->
        </div>
      </div>
      <div class="addbutton" @click="addfile">+添加文件</div>
    </div>
    <div class="videoInfo row_item_3" v-if="videoList && videoList.length">
      <div
        class="video_item"
        v-for="item in videoList"
        :key="item.id"
        @click="videoClick(item)"
      >
        <el-tooltip
          :disabled="
            item.audit_status === 'hidden' && item.audit_remarks ? false : true
          "
          :content="item.audit_remarks"
          placement="bottom"
          effect="light"
          popper-class="popperClass"
        >
          <div class="status" :class="item.audit_status" v-if="navList">
            <!-- {{ navList.find((f) => f.id == item.status) }} -->
            <!-- :style="{
                color: navList.find((f) => f.id == item.status)
                  ? navList.find((f) => f.id == item.status).color
                  : 'red',
              }" -->
            <i
              class="iconfont"
              :style="{
                color: navList.find((f) => f.id == item.audit_status)
                  ? navList.find((f) => f.id == item.audit_status).color
                  : 'red',
              }"
            >
              {{
                navList.find((f) => f.id === item.audit_status)
                  ? navList.find((f) => f.id === item.audit_status).icon
                  : ""
              }}
            </i>

            <span v-if="item.audit_status === 'unreviewed'">待审核</span>
            <span v-if="item.audit_status === 'normal'">已通过</span>
            <span v-if="item.audit_status === 'hidden'">审核驳回</span>
          </div>
        </el-tooltip>
        <div class="video_top_img">
          <img v-if="item.cover_img" :src="item.cover_img" />
          <img v-else src="../../assets/image/videoDefult.png" />
        </div>
        <div class="title ellipsis_single_2">
          {{ item.title }}
        </div>
        <div class="author ellipsis_single_1">
          <span>作者：</span>
          <span>{{ item.author }}</span>
        </div>
        <div class="video_bottom">
          <!-- <div class="time row" v-if="item.create_time">
            <span class="icon">
              <svg
                t="1756271777790"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4583"
                id="mx_n_1756271777792"
                width="16"
                height="16"
              >
                <path
                  d="M1024 512C1024 229.230204 794.769796 0 512 0 229.230204 0 0 229.230204 0 512 0 794.769796 229.230204 1024 512 1024 794.769796 1024 1024 794.769796 1024 512ZM70.62069 512C70.62069 268.232934 268.232934 70.62069 512 70.62069 755.767066 70.62069 953.37931 268.232934 953.37931 512 953.37931 755.767066 755.767066 953.37931 512 953.37931 268.232934 953.37931 70.62069 755.767066 70.62069 512ZM512.015395 476.689655C521.717389 476.689655 529.655172 484.608406 529.655172 494.329432L529.655172 247.187809C529.655172 227.686435 513.846184 211.877464 494.344828 211.877464 474.843471 211.877464 459.034483 227.686435 459.034483 247.187809L459.034483 494.329432C459.034483 523.649148 482.752565 547.310345 512.015395 547.310345L759.157018 547.310345C778.658392 547.310345 794.467363 531.501356 794.467363 512 794.467363 492.498644 778.658392 476.689655 759.157018 476.689655L512.015395 476.689655Z"
                  fill="#000000"
                  p-id="4584"
                ></path>
              </svg>
            </span>
            <span class="time_info">{{ item.create_time.split(" ")[0] }}</span>
          </div> -->
          <!-- <div class="click_num row" v-if="item.click_num">
            <span class="icon">
              <svg
                t="1756802009061"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5002"
                width="20"
                height="20"
              >
                <path
                  d="M515.2 224c-307.2 0-492.8 313.6-492.8 313.6s214.4 304 492.8 304 492.8-304 492.8-304S822.4 224 515.2 224zM832 652.8c-102.4 86.4-211.2 140.8-320 140.8s-217.6-51.2-320-140.8c-35.2-32-70.4-64-99.2-99.2-6.4-6.4-9.6-12.8-16-19.2 3.2-6.4 9.6-12.8 12.8-19.2 25.6-35.2 57.6-70.4 92.8-102.4 99.2-89.6 208-144 329.6-144s230.4 54.4 329.6 144c35.2 32 64 67.2 92.8 102.4 3.2 6.4 9.6 12.8 12.8 19.2-3.2 6.4-9.6 12.8-16 19.2C902.4 585.6 870.4 620.8 832 652.8z"
                  p-id="5003"
                ></path>
                <path
                  d="M512 345.6c-96 0-169.6 76.8-169.6 169.6 0 96 76.8 169.6 169.6 169.6 96 0 169.6-76.8 169.6-169.6C681.6 422.4 604.8 345.6 512 345.6zM512 640c-67.2 0-121.6-54.4-121.6-121.6 0-67.2 54.4-121.6 121.6-121.6 67.2 0 121.6 54.4 121.6 121.6C633.6 582.4 579.2 640 512 640z"
                  p-id="5004"
                ></path>
              </svg>
            </span>

            <span> {{ item.click_num }}</span>
          </div> -->
        </div>
        <div class="operate">
          <div
            class="edit_btn btn_item"
            v-if="item.audit_status !== 'normal'"
            @click.stop="addClick(item)"
          >
            修改
          </div>
          <div
            class="addliebiao-right-bottom-xiazai"
            @click.stop="DownloadFile(item)"
            v-if="item.audit_status == 'normal'"
          >
            <i class="iconfont" style="color: #ff3d3d">
              <svg
                t="1756175746922"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4753"
                width="16"
                height="16"
              >
                <path
                  d="M853.333333 853.333333a42.666667 42.666667 0 0 1 0 85.333334H170.666667a42.666667 42.666667 0 0 1 0-85.333334h682.666666zM512 85.504a42.666667 42.666667 0 0 1 42.666667 42.666667v515.370666l204.373333-204.373333a42.666667 42.666667 0 0 1 63.914667 56.277333l-3.584 4.010667-277.376 277.546667a42.666667 42.666667 0 0 1-56.32 3.584l-4.010667-3.541334-277.12-276.650666a42.666667 42.666667 0 0 1 56.234667-63.957334l4.010666 3.541334L469.333333 644.096V128.170667a42.666667 42.666667 0 0 1 42.666667-42.666667z"
                  fill="#4986FE"
                  p-id="4754"
                ></path>
              </svg>
            </i>
            下载协议
          </div>
          <div
            class="delete_btn btn_item"
            v-if="item.audit_status !== 'normal'"
            @click.stop="deleteClick(item)"
          >
            <i class="iconfont" style="color: #ff3d3d">&#xe8ae;</i>
          </div>
        </div>
      </div>
    </div>
    <el-empty :image-size="200" v-else></el-empty>
    <div class="pages">
      <el-pagination
        :hide-on-single-page="true"
        :page-size="reqObj.limit"
        layout="prev, pager, next"
        :total="total"
        @current-change="changepage"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="删除"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span class="poptext">确定要删除上传的文件吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button class="changecolor" type="primary" @click="removeA()">
          确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- <videoAddEDit
      :dialogVisibleImg="dialogVisibleImg"
      :_id="addEdit_id"
      type="user"
      @success_Click="videoListAsync"
      @close_click="handleClick"
    /> -->
  </div>
</template>
<script>
import videoAddEDit from "../../components/videoAddEDit.vue";
import videoApi from "../../api/popularScienceVideo";
import { getStream } from "../../utils/localstore";
export default {
  name: "videoManage",
  data() {
    return {
      dialogVisible: false,
      dialogVisibleImg: false,
      addEdit_id: 0,
      navList: [
        {
          name: "待审核",
          id: "unreviewed",
          icon: "\ue816",
          color: "#ff913d",
        },
        {
          name: "已通过",
          id: "normal",
          icon: "\ue88e",
          color: "#06c686",
        },
        {
          name: "审核驳回",
          id: "hidden",
          icon: "\ue72c",
          color: "#ff3d3d",
        },
      ],
      reqObj: {
        status: "unreviewed", //未审核'unreviewed', 通过'normal',驳回'hidden'
        title: "",
        page: 1,
        limit: 6,
      },
      total: 0,
      videoList: [],
      deleteID: null,
    };
  },
  created() {
    this.videoListAsync();
  },
  methods: {
    videoClick(item) {
      this.$router.push(`/popularScienceVideoDetail?id=${item.id}`);
    },
    addfile() {
      // this.dialogVisibleImg = true;
      // this.addEdit_id = 0;
      this.$router.push("/videoUpload");
    },
    addClick(item) {
      // this.dialogVisibleImg = true;
      // this.addEdit_id = item.id;
      this.$router.push(`/videoUpload?id=${item.id}&type=user`);
    },
    deleteClick(item) {
      this.dialogVisible = true;
      this.deleteID = item.id;
    },
    async DownloadFile(item) {
      // console.log(item, "item");
      if (!item.contract_path) return this.$message.error("暂无协议文件");
      let url = item.contract_path;
      // let url = item.file_path;
      let name = url.split("/")[url.split("/").length - 1];
      let res = await getStream(url, {}, { responseType: "blob" });
      console.log(res, "res");
      if (res.message !== "接口异常") {
        const blob = new Blob([res], {
          type: "application/pdf;charset=utf-8",
        });
        let url2 = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.style.display = "none";
        link.download = name;
        link.href = url2;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        console.log("没有数据");
        this.$message.error("获取地址异常");
      }
    },
    async removeA() {
      try {
        let res = await videoApi.myVideoDelete(this.deleteID);
        if (res.code === 1) {
          this.dialogVisible = false;
          this.$message.success("删除成功");
          this.videoListAsync();
        }
      } catch (error) {
        console.log(error);
      }
    },
    navClick(item) {
      this.reqObj.status = item.id;
      this.videoListAsync();
    },
    changepage(val) {
      this.reqObj.page = val;
      this.videoListAsync();
    },
    async videoListAsync(data = this.reqObj) {
      this.dialogVisibleImg = false;
      try {
        let res = await videoApi.myVideoList(data);
        if (res.code == 1) {
          this.videoList = res.data.list;
          this.total = res.data.total;
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClick(val) {
      this.dialogVisibleImg = val;
      this.addEdit_id = 0;
    },
  },
  components: {
    videoAddEDit,
  },
};
</script>
<style scoped lang="less">
.pages {
  text-align: center;
}
.videoManage {
  .info_nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      margin: 5px 0 0 0;
      display: flex;
      .isA {
        border-bottom: 3px solid #508ffa !important;
      }
      .nav_item {
        text-align: center;
        padding: 5px 0;
        font-size: 16px;
        margin: 20px;
        border-bottom: 3px solid transparent;
        cursor: pointer;
      }
    }
    .addbutton {
      width: 92px;
      height: 29px;
      background: linear-gradient(136deg, #57c9fb 0%, #578cfb 100%);
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.16);
      border-radius: 4px;
      font-size: 13px;
      color: #fff;
      text-align: center;
      line-height: 29px;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .videoInfo {
    .video_item:hover {
      transform: scale(102%);
      box-shadow: 0px 3px 20px 1px rgba(0, 0, 0, 0.16);
    }
    .video_item:not(.video_item:nth-child(4n)) {
      // background: red;
      // margin-right: 30px;
    }
    .video_item {
      cursor: pointer;
      max-width: 400px;
      padding: 15px;
      box-shadow: 0px 0px 10px 1px #eaf1f5;
      margin-bottom: 32px;
      border-radius: 10px;
      position: relative;
      .operate {
        margin-top: 5px;
        display: flex;
        justify-content: flex-end;
        .btn_item:not(.btn_item:last-child) {
          margin-right: 24px;
        }
        .btn_item {
          width: fit-content;
          border-radius: 8px;
        }
        .edit_btn {
          // padding: 5px 20px;
          padding: 10px 20px;
          background: linear-gradient(180deg, #ecf1fe 0%, #cbd9fe 100%);
          box-shadow: 0px 1px 3px 1px #b7cafc;
          font-size: 14px;
          color: #7599f5;
        }
        .delete_btn {
          padding: 10px;
          background: linear-gradient(180deg, #fee6e6 0%, #fecaca 100%);
          box-shadow: 0px 1px 3px 1px #f6c3c3;
        }
      }
      .video_top_img {
        // width: 330px;
        width: 100%;
        height: 185px;
        border-radius: 10px;
        overflow: hidden;
        img {
          width: 100%;
          // height: 100%;
        }
      }
      .unreviewed {
        background: #fff3e9;
        color: #ff913d;
      }
      .normal {
        background: #f5fffa;
        span {
          color: #06c686;
        }
      }
      .hidden {
        background: #ffe9e9;
        span {
          color: #ff3d3d;
        }
      }
      .status {
        border-radius: 0px 10px 0px 10px;
        padding: 5px;
        position: absolute;
        top: 0px;
        right: 0px;
      }
      .title {
        margin: 5px 0;
        font-size: 17px;
        line-height: 25px;
        height: 50px;
        color: #1c1c1c;
      }
      .author {
        height: 20px;
        color: #3b5c75;
        // margin-bottom: 23px;
        margin-bottom: 10px;
        span:nth-child(1) {
          width: 50px;
          white-space: nowrap;
        }
      }
      .video_bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .operate {
        margin-top: 10px;
        .addliebiao-right-bottom-xiazai:hover {
          background: #4986fe;
          color: #ffffff !important;
          .iconfont {
            path {
              fill: #fff !important;
            }
          }
        }
        .addliebiao-right-bottom-xiazai {
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #4986fe;
          padding: 3px 6px;
          font-size: 16px;
          color: #4986fe;
        }
      }
      .row {
        display: flex;
        align-items: center;
        font-size: 16px;
        span:nth-child(1) {
          margin-right: 10px;
        }
        .icon {
          height: 20px;
        }
      }
    }
  }
}
</style>
